import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './ForgotPassword.module.scss';
import homeImage from '../../../assets/landingPage.png';
import logo from '../../../assets/Logo.png';
import { Input, Button } from '@src/components/ui';
const ForgotPassword = () => {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        email: '',
    });
    const [error, setError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const handleChange = (field) => (value) => {
        if (emailError)
            setEmailError('');
        if (error)
            setError('');
        setForm((prev) => ({ ...prev, [field]: value }));
    };
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
    const handleSubmit = async () => {
        setError('');
        if (!form.email) {
            setEmailError('Email is required');
            return;
        }
        if (!validateEmail(form.email)) {
            setEmailError('Please enter a valid email address');
            return;
        }
        setLoading(true);
        try {
            const response = await fetch('/api/v1/forgot-password/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    email: form.email,
                }),
            });
            const data = await response.json();
            if (response.ok && data.success) {
                setSuccessMessage('Password reset instructions have been sent to your email address.');
                setForm({ email: '' });
                setTimeout(() => {
                    navigate('/account/login');
                }, 3000);
            }
            else {
                setError(data.message || 'Failed to send password reset email. Please try again.');
            }
        }
        catch (err) {
            setError('An error occurred. Please try again.');
        }
        setLoading(false);
    };
    const clearForm = () => {
        setError('');
        setEmailError('');
        setForm({ email: '' });
    };
    return (_jsxs("div", { className: styles.createAccountWrapper, children: [successMessage && _jsx("div", { className: styles.successBanner, children: successMessage }), _jsx("img", { src: homeImage, alt: "Veterinary technology for animal care", className: styles.fullscreenBackground }), _jsxs("div", { className: styles.inputContainer, children: [_jsx(Link, { to: "/", className: styles.nav__logoWrapper, children: _jsx("img", { src: logo, style: { height: '50px', width: '217px' } }) }), _jsx("h2", { children: "Forgot Password" }), _jsx("p", { className: styles.description, children: "Enter your email address below and we'll send you instructions to reset your password." }), _jsx(Input, { label: !emailError ? 'Email Address' : `Email Address: ${emailError}`, className: styles.inputItem, width: "100%", value: form.email, onChange: handleChange('email'), onFocus: () => (error || emailError) && clearForm(), error: !!emailError || !!error, type: "email" }), error && _jsx("p", { className: styles.error, children: error }), _jsx(Button, { variant: "primaryV2", label: loading ? 'Sending...' : 'Send Reset Instructions', size: "large", onClick: handleSubmit, disabled: loading, className: styles.resetButton }), _jsx("div", { className: styles.loginContainer, children: _jsx(Link, { to: "/account/login", children: "Back to Login" }) })] })] }));
};
export default ForgotPassword;
